import ConformanceTargetSelect from '@/pages/report/reportComponents/ConformanceTargetSelect';
import GlobalDomainSelect from '@/pages/report/reportComponents/GlobalDomainSelect';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ReturnToButton } from './ReturnToButton';

function PageTitle({
    title = 'No Title',
    rightSideText = null,
    showDomainSelect = false,
    showConformanceTarget = false,
    returnTo = null,
}) {
    return (
        <Grid
            container
            sx={{
                alignItems: 'center',
                gap: 2,
                justifyContent: 'space-between',
            }}
        >
            <Box
                component='h1'
                sx={{
                    fontSize: '1.65rem',
                    fontWeight: 600,
                }}
            >
                {returnTo && returnTo.path ? (
                    <ReturnToButton path={returnTo.path} label={returnTo.label} />
                ) : (
                    title
                )}
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    gap: 1.35,
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                }}
            >
                {rightSideText}
                {showDomainSelect && <GlobalDomainSelect />}
                {showConformanceTarget && <ConformanceTargetSelect small />}
            </Box>
        </Grid>
    );
}

export default PageTitle;
